import { toast } from '@systemeio/ui'
import {
  CampaignSteErrorsApiInterface,
  CampaignStepErrorsInterface,
} from 'modules/campaigns/campaign-steps/types/campaign-step-error-response-interface'
import { Dispatch, SetStateAction } from 'react'

export const setCampaignStepErrors = (
  setErrors: Dispatch<SetStateAction<CampaignStepErrorsInterface>>,
  campaignStepErrors: CampaignSteErrorsApiInterface,
) => {
  setErrors(prev => ({
    ...prev,
    excludedWeekdays: campaignStepErrors?.excludedWeekdays?.join('') || '',
    stepBefore: campaignStepErrors?.stepBefore?.join('') || '',
    delayValue: campaignStepErrors?.delayValue?.join('') || '',
    timeOfTheDay: campaignStepErrors?.timeOfTheDay?.join('') || '',
    body: campaignStepErrors?.mailing?.currentEmail?.body?.join('') || '',
    fromEmail: campaignStepErrors?.mailing?.currentEmail?.fromEmail?.join('') || '',
    fromName: campaignStepErrors?.mailing?.currentEmail?.fromName?.join('') || '',
    subject: campaignStepErrors?.mailing?.currentEmail?.subject?.join('') || '',
    previewText: campaignStepErrors?.mailing?.currentEmail?.previewText?.join('') || '',
    attachments: campaignStepErrors?.mailing?.currentEmail?.attachments?.join('') || '',
  }))
  if (campaignStepErrors?.mailing?.currentEmail?.fromEmail)
    toast.error(campaignStepErrors.mailing.currentEmail.fromEmail.join(''))
}
